import { CASE_DETAIL_URL, CASE_TEAM_DETAIL_URL } from 'src/constants/constants.js';

const getCaseManagerIdFromPath = pathname => {
  const teamCasePrefix = `${CASE_TEAM_DETAIL_URL}/`;
  const myCasePrefix = `${CASE_DETAIL_URL}/`;

  if (pathname.indexOf(teamCasePrefix) === 0) return pathname.slice(teamCasePrefix.length).split('/')[0];
  if (pathname.indexOf(myCasePrefix) === 0) return pathname.slice(myCasePrefix.length).split('/')[0];

  return '';
};

const getCaseManagerIdFromSession = () => {
  const headerDetailsObject = sessionStorage.getItem('headerDetails');
  const headerDetails = headerDetailsObject ? JSON.parse(headerDetailsObject) : {};

  return headerDetails.caseManagerId || sessionStorage.getItem('caseManagerId');
};

const getCaseDetailBaseUrl = pathname => {
  if (pathname.indexOf(`${CASE_TEAM_DETAIL_URL}/`) === 0) return CASE_TEAM_DETAIL_URL;
  if (pathname.indexOf(`${CASE_DETAIL_URL}/`) === 0) return CASE_DETAIL_URL;

  return sessionStorage.getItem('caseType') === 'teamCase' ? CASE_TEAM_DETAIL_URL : CASE_DETAIL_URL;
};

const getCaseDetailPath = location => {
  const pathname = location && location.pathname ? location.pathname : '';
  const caseManagerId = getCaseManagerIdFromPath(pathname) || getCaseManagerIdFromSession();

  return `${getCaseDetailBaseUrl(pathname)}/${caseManagerId}`;
};

export default getCaseDetailPath;